import React from "react";
import { connect } from "react-redux";
import { removeCertificateExpiryWarning } from "../../reduxStore/actions/auth";

// Certificates expiry info is stored in backend /Certs/certificates_expiry.json

const CertificatesExpiryReminder = props => {
  const { user } = props;
  const date = new Date();
  const currentTimestamp = date.getTime();
  let MedicareSiteCertExpiry, NASHCertExpiry, MedicareSiteCertForERXExpiry;
  let isShowMedicareSiteCertExpiry,
    isShowNASHCertExpiry,
    isShowMedicareSiteCertForERXExpiry;

  if (
    user.certificatesExpiryInfo &&
    user.certificatesExpiryInfo.MedicareSiteCertExpiry
  ) {
    let deviceExpiry = user.certificatesExpiryInfo.MedicareSiteCertExpiry.split(
      " "
    )[0];
    isShowMedicareSiteCertExpiry =
      currentTimestamp >
      new Date(deviceExpiry).getTime() - 1000 * 3600 * 24 * 30;
    MedicareSiteCertExpiry =
      deviceExpiry.split("-")[2] +
      "/" +
      deviceExpiry.split("-")[1] +
      "/" +
      deviceExpiry.split("-")[0];
  }

  if (
    user.certificatesExpiryInfo &&
    user.certificatesExpiryInfo.NASHCertExpiry
  ) {
    let deviceExpiry = user.certificatesExpiryInfo.NASHCertExpiry.split(" ")[0];
    isShowNASHCertExpiry =
      currentTimestamp >
      new Date(deviceExpiry).getTime() - 1000 * 3600 * 24 * 30;
    NASHCertExpiry =
      deviceExpiry.split("-")[2] +
      "/" +
      deviceExpiry.split("-")[1] +
      "/" +
      deviceExpiry.split("-")[0];
  }

  if (
    user.certificatesExpiryInfo &&
    user.certificatesExpiryInfo.MedicareSiteCertForERXExpiry
  ) {
    let deviceExpiry = user.certificatesExpiryInfo.MedicareSiteCertForERXExpiry.split(
      " "
    )[0];
    isShowMedicareSiteCertForERXExpiry =
      currentTimestamp >
      new Date(deviceExpiry).getTime() - 1000 * 3600 * 24 * 60;
    MedicareSiteCertForERXExpiry =
      deviceExpiry.split("-")[2] +
      "/" +
      deviceExpiry.split("-")[1] +
      "/" +
      deviceExpiry.split("-")[0];
  }

  return (
    <div
      style={{ width: "100%", zIndex: 200, position: "absolute", top: "75px" }}
    >
      {isShowMedicareSiteCertExpiry && (
        <p className="bg-danger text-white text-center row">
          <span className="col-10 offset-1">
            WARNING! Expiring {MedicareSiteCertExpiry} - please renew the
            Medicare Site Certificate
          </span>
          <i
            className="fas fa-times col-1 mt-1"
            onClick={() =>
              props.removeCertificateExpiryWarning("MedicareSiteCertExpiry")
            }
          />
        </p>
      )}
      {isShowNASHCertExpiry && (
        <p className="bg-danger text-white text-center row">
          <span className="col-10 offset-1">
            WARNING! Expiring {NASHCertExpiry} - please renew the NASH
            Certificate
          </span>
          <i
            className="fas fa-times col-1 mt-1"
            onClick={() =>
              props.removeCertificateExpiryWarning("NASHCertExpiry")
            }
          />
        </p>
      )}
      {isShowMedicareSiteCertForERXExpiry && (
        <p className="bg-danger text-white text-center row">
          <span className="col-10 offset-1">
            WARNING! Expiring {MedicareSiteCertForERXExpiry} - please renew the
            Medicare Site Certificate for eRx
          </span>
          <i
            className="fas fa-times col-1 mt-1"
            onClick={() =>
              props.removeCertificateExpiryWarning(
                "MedicareSiteCertForERXExpiry"
              )
            }
          />
        </p>
      )}
      {user &&
        (!user.certificatesExpiryInfo ||
          Object.keys(user.certificatesExpiryInfo).length === 0) && (
          <p className="bg-danger text-white text-center row">
            <span className="col-10 offset-1">
              WARNING! Certificate expiry info cannot be found. Please check if
              it is set correctly in backend file of certificates_expiry.json.
            </span>
          </p>
        )}
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.auth.user
});

const mapDispatchToProps = dispatch => ({
  removeCertificateExpiryWarning: certExpiryType =>
    dispatch(removeCertificateExpiryWarning(certExpiryType))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CertificatesExpiryReminder);
